import apiFetch from '../apiFetch'

export default function (saleId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/sale/${saleId}/sendToValidation`, method: 'PUT', body: null, token: token, lastAccessDate })
}
